import React from "react";
import { InfiniteScroll } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Search from "../../../../components/Search";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import Table from "../../../../components/Table";
import AccomplishmentReportPresenter from "./AccomplishmentReportPresenter";
import Progress from "../../../../components/Progress";

class AccomplishmentList extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AccomplishmentReportPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "employees";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleViewData(object) {
    this.navigateTo(`/acc/${this.getCollectionName()}/${object.id}`);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;

    const excluded = ["surname", "Firstname", "Middlename"];
    const excludeFields = Object.keys(schema.fields).filter(
      (key) => !excluded.includes(key)
    );

    return (
      <>
        <div style={{ margin: "1rem 0" }}>
          <CardView style={{ borderRadius: 0 }}>
            <Search
              schemas={this.getSchemas()}
              onSubmit={this.searchSubmit.bind(this)}
              fields={schema.fields}
            />
          </CardView>
        </div>
        <div className="overflow-auto">
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-block">
                  <h4 className="text-primary">List of Employee</h4>
                </div>
              </CardView>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectData={this.handleViewData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, excludeFields)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(AccomplishmentList);
